import { writePersistedUserLanguage } from "@/lib/languagePolicy";
import { reportSiteLanguageConsoleOnce } from "@/lib/siteDebug";
import { getEffectiveSiteLanguage } from "@/lib/siteLanguage";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Sincroniza <html lang>, og:locale y user_language persistido con el idioma resuelto por i18next.
 * El idioma viene del Worker (cloudflareEdge detector → window.__TEMPLATE_CONFIG__.language /
 * cookie user_language). NO re-derivamos geo acá: si el Worker dice "es-AR", lo respetamos.
 */
export const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!i18n.isInitialized || !i18n.language) return;
    reportSiteLanguageConsoleOnce();
  }, [i18n.isInitialized, i18n.language]);

  useEffect(() => {
    if (!i18n.language) return;
    const doc = getEffectiveSiteLanguage(i18n.language);
    document.documentElement.lang = doc;
    document.documentElement.setAttribute("data-lang", doc);
    writePersistedUserLanguage(doc);
    const ogLocale = document.querySelector('meta[property="og:locale"]');
    if (ogLocale) {
      ogLocale.setAttribute("content", doc.replace(/-/g, "_"));
    }
  }, [i18n.language]);

  return <>{children}</>;
};
